// Temp to add more events
import ArrowRight from '@berlitz/streamline-icons/lib/bold/52-Arrows-Diagrams/01-Arrows/ArrowButtonRight'
import React from 'react'
import InputMask from 'react-input-mask'
import { IMaxInput } from './interface'
import { IconWrapper, StyledInput, SubmitButton, Wrapper } from './style'

const Input = ({
  ariaDescribedby,
  autocomplete,
  button,
  defaultValue,
  disabled,
  ghost,
  hideLabel,
  id,
  invalid,
  mask,
  maskChar,
  maxLength,
  minLength,
  name,
  onBlur,
  onChange,
  onClick,
  placeholder,
  required,
  type,
  value,
  icon,
  onKeyDown,
  onKeyPress,
  onKeyUp,
}: IMaxInput) => {
  const placeholderText = placeholder && placeholder + (required && hideLabel ? ' *' : '')

  const inputProps = {
    'aria-describedby': ariaDescribedby,
    'data-key': 'max-input__field',
    autoComplete: autocomplete,
    button,
    defaultValue,
    disabled,
    ghost,
    id,
    invalid,
    maxLength,
    minLength,
    name,
    onChange,
    placeholder: placeholderText,
    required,
    type,
    value,
    onKeyDown,
    onKeyPress,
    onKeyUp,
  }

  return (
    <Wrapper data-key="max-input">
      {mask ? (
        <InputMask
          disabled={disabled}
          mask={mask}
          maskChar={maskChar}
          onBlur={onBlur}
          onChange={onChange}
          value={value}
        >
          {(maskProps) => <StyledInput {...inputProps} {...maskProps} />}
        </InputMask>
      ) : (
        <StyledInput {...inputProps} />
      )}
      {button && (
        <SubmitButton onClick={onClick} data-key="max-input__submit">
          {icon ? icon : <ArrowRight size="xs" color="brand02" />}
        </SubmitButton>
      )}
      {icon && !button && <IconWrapper>{icon}</IconWrapper>}
    </Wrapper>
  )
}

export default React.memo(Input)
